import React, { useCallback, useRef } from "react";
import { useEffect, useState } from "react";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import useSize from "../../useSize/useSize";
import Filter from "./Filter/Filter";
import Loading from "../../Loading/Loading";
import NotFound from "../../NotFound/NotFound";
import Menu from "./Menu/Menu";
import Total from "./Total/Total";
import { VirtualScroller } from "primereact/virtualscroller";
import UserCard from "./UserCard";
import moment from "moment";

import { toJpeg } from "html-to-image";

const backend = await new Backend().init();

export default function UserSettlement(props) {
  const user_id = props.user_id;

  const windowSize = useSize();

  const elementRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState([]);
  const [broker, setBroker] = useState(null);

  const [date_start, setDate_Start] = useState(
    moment(moment(), "YYYY-MM-DD").clone().subtract(6, "days"),
  );
  const [date_end, setDate_End] = useState(
    moment(moment(), "YYYY-MM-DD").clone(),
  );

  useEffect(() => {
    loadBrokerUser();
  }, []);

  const loadBrokerUser = (a, b) => {
    setDate_Start(a === undefined ? date_start : a);
    setDate_End(b === undefined ? date_end : b);

    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),

      start: a === undefined ? date_start : a,
      end: b === undefined ? date_end : b,
      broker_id: user_id,
    };
    backend.load_broker_user(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setUser(r.userlist);
        setBroker(r.broker);
      } else {
        toast.error(r.message);
      }
    });
  };

  const htmlToImageConvert = () => {
    if (!elementRef.current) return;
    toJpeg(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `${broker.username}-SETTLEMENT.jpeg`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => console.log(err));
  };
  return (
    <div
      style={{
        width: windowSize[0] - 100,
        height: windowSize[1] - 170,
      }}
    >
      <Filter
        records={user.length}
        user={loadBrokerUser}
        htmlToImageConvert={htmlToImageConvert}
      />

      <div ref={elementRef}>
        <Menu />
        <div
          style={{
            height: windowSize[1] - 270,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <div className="loadingContainer">
              <Loading height={windowSize[1] - 270} />
            </div>
          ) : user.length > 0 ? (
            <VirtualScroller
              style={{
                height: windowSize[1] - 270,
              }}
              items={user}
              itemSize={50}
              itemTemplate={(item, index) => {
                return <UserCard key={item.id} item={item} />;
              }}
            />
          ) : (
            <NotFound
              height={windowSize[1] - 270}
              title={"Nothing here"}
              subtext={"No User Settlement Found."}
            />
          )}
        </div>

        <Total
          key={loading}
          start={date_start}
          end={date_end}
          user_id={user_id}
        />
      </div>
    </div>
  );
}
